export const FAVOURITES_COOKIE_NAME = "cars-favourites";
export const FAVOURITES_LS_NAME = "cars-favourites";
export const UTM_DATA_LS_KEY = "cars-utmData";
export const UTM_DATA_TIME_LS_KEY = "cars-utmData-time";
